import { menuList } from '../../../../core.routes';

export const generatePermissions = (menuList: any) => {
  const permissionsDictionary: any = { operations: [], reports: [] };
  const permissionsDictionaryTranslate: any = {};

  const addPermission = (permissionType: string, item: any) => {
    const exists = permissionsDictionary[permissionType].some(
      (perm: any) => perm.value === item.flag
    );
    if (!exists) {
      permissionsDictionary[permissionType].push({
        title: item.label,
        value: item.flag,
      });
      permissionsDictionaryTranslate[item.flag] = { title: item.label };
    }
  };

  for (const section of menuList.ips.concat(menuList.tvf)) {
    for (const item of section.itens) {
      if (section.title === 'Operacional') {
        addPermission('operations', item);
      } else if (section.title === 'Relatórios') {
        addPermission('reports', item);
      }
    }
  }

  return { permissionsDictionary, permissionsDictionaryTranslate };
};

const { permissionsDictionary, permissionsDictionaryTranslate } = generatePermissions(menuList);

export { permissionsDictionary, permissionsDictionaryTranslate };
